// TODO - Type 'any' needs to be fixed.
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Box, Button, Divider } from "@mui/material";
import isAfter from "date-fns/isAfter";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { hasPermission } from "../../../utils/helpers";

interface ShiftData {
	id: number;
	shiftId: string;
	startDate: string | Date;
  createdBy: string | number;
}

interface IDeleteShiftProps {
	shiftData: ShiftData;
	toggleVisibility: (val: boolean) => void;
	isDraftShift?: boolean;
	openShiftCancelDialog?: () => void;
	openDeleteDraftShiftDialog?: () => void;
}

function DeleteShift({
	shiftData,
	toggleVisibility,
	isDraftShift = false,
	openShiftCancelDialog,
	openDeleteDraftShiftDialog,
}: IDeleteShiftProps) {
	const { t } = useTranslation();
  const currentUserId = useSelector((state: any) => state.user?.userData?.id);
	const userRolesWithPermissions = useSelector((state: any) => state.user.userData.userRolesWithPermissions);

	const shiftDate = shiftData?.startDate;

	const isPastShift = (shiftDateTime: Date | string) => {
		return isAfter(new Date(), new Date(shiftDateTime));
	};

	return (
		<>
			{!isPastShift(shiftDate) ? (
				<Box>
					<Button
						color='error'
						size='large'
						variant='text'
						startIcon={<CancelOutlinedIcon />}
						onClick={() => {
							if (!isDraftShift && openShiftCancelDialog) {
								openShiftCancelDialog();
							} else if (isDraftShift && openDeleteDraftShiftDialog) {
								openDeleteDraftShiftDialog();
							}
							toggleVisibility(false);
						}}
						sx={{
							textTransform: "none",
							width: "100%",
							justifyContent: "flex-start",
							// Keep wrapped label lines left-aligned: justifyContent only
							// positions the icon+label group, not the multiline text, which
							// otherwise falls back to the button's default center alignment
							// (visible once longer FR/ES translations wrap to two lines).
							textAlign: "left",
							paddingLeft: "24px",
						}}
						disabled={
							Array.isArray(userRolesWithPermissions) ?
                isDraftShift ? (!hasPermission(userRolesWithPermissions, "FLEX_SCHEDULER.DELETE_DRAFT_SHIFT")
                  && currentUserId.toString() !== shiftData?.createdBy?.toString())
                  : !hasPermission(userRolesWithPermissions, "FLEX_SCHEDULER.CANCEL_PUBLISHED_SHIFT")
                  : false
						}
					>
						{isDraftShift ? t("scheduler_delete-draft-shift") : t("scheduler_cancel-shift")}
					</Button>
					<Divider />
				</Box>
			) : null}
		</>
	);
}

export default DeleteShift;
